module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/store_images/1_02597b577d6417855f2e49d63c51ffa7.png";